/**
 * Payment URLs for Sister Diamonds Programs
 * 
 * These URLs point to Ontraport payment forms
 */

export const PAYMENT_URLS = {
  // Inner Circle Membership
  innerCircle: {
    membership: 'https://events.sisterdiamonds.com/innercircle'
  },
  
  // Inner Edge Program
  innerEdge: {
    fullPay: 'https://support.sisterdiamonds.com/Inneredgefullpay',
    sixPay: 'https://support.sisterdiamonds.com/Inneredge6pay'
  },
  
  // Signature Coaching Program
  signatureCoaching: {
    fullPay: 'https://support.sisterdiamonds.com/Signaturecoachingfullpay',
    sixPay: 'https://support.sisterdiamonds.com/Signaturecoaching6pay'
  }
};

/**
 * Helper function to redirect to payment page
 */
export const redirectToPayment = (url) => {
  window.location.href = url;
};
